(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ty-product-guide"] && !Shopify.designMode) return;
  try {
    const scrollToGuide = (guide) => {
    guide.open = true;
    const chartName = guide.dataset.tySizeChart;
    const chart = chartName ? [...guide.querySelectorAll('img')].find(img => img.src.includes(chartName)) : null;
    const target = chart || guide;
    target.classList.add('ty-guide-scroll-target');
    target.scrollIntoView({ block: 'start', behavior: 'instant' });
    guide.querySelector('summary')?.focus({ preventScroll: true });
  };
  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-ty-guide-target]');
    if (!link) return;
    const guide = document.getElementById(link.dataset.tyGuideTarget);
    if (!guide) return;
    event.preventDefault();
    scrollToGuide(guide);
  });
  const openLinkedGuide = () => {
    if (!location.hash.startsWith('#TyGuide-')) return;
    const guide = document.getElementById(location.hash.slice(1));
    if (guide) {
      scrollToGuide(guide);
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', openLinkedGuide, { once: true });
  else openLinkedGuide();
  window.addEventListener('hashchange', openLinkedGuide);
  } catch(e) { console.error(e); }
})();

})();
